import { PageAction } from 'skin/ts/Skin/model/PageAction';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class APISkinMobileWeb extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'APISkinMobileWeb'
        });
    }
    get IN() {
        return {
            pageAction: (data) => {
                this?.logger?.log('pageAction:', 'params:', data);
                const player = this.tag?.snapshot?.player;
                switch (data.action) {
                    case PageAction.MUTE:
                        if (this.utils.Type.isDefined(player?.muted)) {
                            player.muted = true;
                        }
                        break;
                    case PageAction.UNMUTE:
                        if (this.utils.Type.isDefined(player?.muted)) {
                            player.muted = false;
                        }
                        break;
                }
            }
        };
    }
}
